var render, staticRenderFns
import script from "./dynamicTableItem.vue?vue&type=script&lang=js"
export * from "./dynamicTableItem.vue?vue&type=script&lang=js"
import style0 from "./dynamicTableItem.vue?vue&type=style&index=0&id=fbc455e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc455e2",
  null
  
)

component.options.__file = "dynamicTableItem.vue"
export default component.exports